import React from 'react';
import styles from './CEOStory.module.css';
import paulTeamImg from '../../../assets/ceo/paul-team.jpg';

function CEOStory() {
    return (
        <section className={styles.ceoSection}>
            <div className={styles.ceoInner}>
                <div className={styles.ceoHead}>
                    <span className={styles.eyebrow}>Why we exist</span>
                    <h2>GLP-1s work. Everyone deserves access.</h2>
                    <p>
                        75% of Americans carry excess weight — and most have already tried everything. The problem was
                        never willpower. GLP-1s are changing what's possible, and TB2 Health exists to make the path to
                        them clear, honest, and supported.
                    </p>
                </div>

                <div className={styles.ceoBio}>
                    <div className={styles.ceoPhotoCol}>
                        <div className={styles.ceoPhoto}>
                            <img src={paulTeamImg} alt="Paul Moss with team" />
                            <div className={styles.ceoPhotoCard}>
                                <strong>Paul Moss</strong>
                                <span>CEO &amp; Co-Founder, TB2 Health</span>
                                <div className={styles.ceoPhotoTag}>On a mission to make GLP-1 care accessible</div>
                            </div>
                        </div>

                        <div className={styles.ceoStats}>
                            <div className={styles.ceoStat}>
                                <div className={styles.statNum}>75%</div>
                                <div className={styles.statLbl}>of Americans struggle with weight</div>
                            </div>
                            <div className={styles.ceoStat}>
                                <div className={styles.statNum}>200+</div>
                                <div className={styles.statLbl}>comorbidities linked to excess weight</div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.ceoStory}>
                        <div className={styles.storyBlock}>
                            <div className={styles.storyBlockLabel}>The reality</div>
                            <h3>Most people who struggle with weight have already tried everything</h3>
                            <p>
                                Carrying excess weight isn't a willpower problem — it's a metabolic one. It can feel
                                isolating, discouraging, and hard to talk about. Most people who come to TB2 Health have
                                already done the diets, the programs, the cycles of losing and gaining back. That shared
                                experience is why we take this so seriously, and why we built something we'd actually want
                                to use ourselves.
                            </p>
                        </div>

                        <div className={styles.ceoPullquote}>
                            <blockquote>
                                "When GLP-1s helped me lose weight, and then so much misinformation was polluting the
                                media — <em>we had to start something that could be a beacon of truth</em> for those
                                trying to figure out if GLP-1s are right for them."
                            </blockquote>
                            <cite>— Paul Moss, CEO &amp; Co-Founder of TB2 Health</cite>
                        </div>

                        <div className={styles.storyBlock}>
                            <div className={styles.storyBlockLabel}>What changed</div>
                            <h3>GLP-1s work — and the evidence is overwhelming</h3>
                            <p>
                                GLP-1 medications have shown consistent, meaningful results in clinical trials: sustained
                                weight loss, improved metabolic markers, and real quality-of-life change. The problem was
                                never the medication — it was the noise around it. Misinformation, inaccessibility, and
                                lack of honest clinical guidance were keeping people from something that could genuinely
                                help them. Closing that gap is what TB2 Health is built to do.
                            </p>
                        </div>

                        <div className={styles.storyBlock}>
                            <div className={styles.storyBlockLabel}>How we help</div>
                            <h3>Care that respects how personal this is</h3>
                            <p>
                                Weight is one of the most personal topics there is — and our model reflects that. It's
                                asynchronous by design: more like texting your clinician than sitting in a waiting room.
                                Complete an intake from your phone, a licensed clinician reviews everything, and care
                                begins on your terms. And it doesn't stop when the medication does — long-term metabolic
                                and cardiovascular support is built into the plan from the start.
                            </p>
                        </div>

                        <div className={styles.ceoTeam}>
                            <h3>The people making it happen</h3>
                            <div className={styles.teamGrid}>
                                <div className={styles.teamMember}>
                                    <div className={styles.teamAvatar}>AA</div>
                                    <div className={styles.teamInfo}>
                                        <strong>Dr. Antoni Adamrovich</strong>
                                        <span>
                                            Chief of Medicine. Brings deep clinical rigor to every protocol — his
                                            positions on treatment have consistently proven ahead of their time.
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.teamMember}>
                                    <div className={styles.teamAvatar}>PM</div>
                                    <div className={styles.teamInfo}>
                                        <strong>Paul Moss</strong>
                                        <span>
                                            Founder. Came to this personally, stayed for the mission. Believes the most
                                            important thing TB2 Health can offer is honesty.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CEOStory;
